/**
 * @generated SignedSource<<3d76114811fd7d37ed624e2a180dfc52>>
 * @relayHash 1443c1f619f4644b1743918c56fc64b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae871846c8152627ad55289bb6491a434a71535519644469695415cab889d84e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PublicLinkSiteStatus = "BLOCKED_BY_ORG" | "OFF" | "ON" | "%future added value";
export type PublicLinkSpaceStatus = "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_PRODUCT" | "OFF" | "ON" | "%future added value";
export type useShowPublicLinkInShareSettingsQuery$variables = {
  skipSite: boolean;
  skipSpace: boolean;
  spaceId: string;
};
export type useShowPublicLinkInShareSettingsQuery$data = {
  readonly publicLinkSiteStatus?: {
    readonly status: PublicLinkSiteStatus;
  } | null | undefined;
  readonly publicLinkSpace?: {
    readonly status: PublicLinkSpaceStatus;
  } | null | undefined;
};
export type useShowPublicLinkInShareSettingsQuery = {
  response: useShowPublicLinkInShareSettingsQuery$data;
  variables: useShowPublicLinkInShareSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipSite"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipSpace"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "status"
  }
],
v4 = [
  {
    "condition": "skipSpace",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "concreteType": "PublicLinkSpace",
        "kind": "LinkedField",
        "name": "publicLinkSpace",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  },
  {
    "condition": "skipSite",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "PublicLinkSitePayload",
        "kind": "LinkedField",
        "name": "publicLinkSiteStatus",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useShowPublicLinkInShareSettingsQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useShowPublicLinkInShareSettingsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "1443c1f619f4644b1743918c56fc64b9",
    "id": "ae871846c8152627ad55289bb6491a434a71535519644469695415cab889d84e",
    "metadata": {},
    "name": "useShowPublicLinkInShareSettingsQuery",
    "operationKind": "query",
    "text": "query useShowPublicLinkInShareSettingsQuery($spaceId:ID!,$skipSpace:Boolean!,$skipSite:Boolean!){publicLinkSpace(spaceId:$spaceId)@skip(if:$skipSpace){status},publicLinkSiteStatus@skip(if:$skipSite){status}}"
  }
};
})();

(node as any).hash = "9f08e3c435409d9de85299d025f40fa9";

export default node;
